import { SelectableItem } from '@philips-internal/oswald-ui-components';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';

enum painScale {
  TOLERATES_MOVEMENTS = 1,
  COUGH_WITH_MOVEMENTS = 2,
  FIGHT_WITH_VENTILATOR = 3,
  UNABLE_CONTROL_MECHANICAL_VENTILATION = 4,
}

export const mechanicalVentilationData: SelectableItem[] = [
  {
    key: String(painScale.TOLERATES_MOVEMENTS),
    label: MessageService.translate('text.tolerates-movement'),
    value: String(painScale.TOLERATES_MOVEMENTS),
  },
  {
    key: String(painScale.COUGH_WITH_MOVEMENTS),
    label: MessageService.translate('text.cough-with-movements'),
    value: String(painScale.COUGH_WITH_MOVEMENTS),
  },
  {
    key: String(painScale.FIGHT_WITH_VENTILATOR),
    label: MessageService.translate('text.fight-with-the-ventilator'),
    value: String(painScale.FIGHT_WITH_VENTILATOR),
  },
  {
    key: String(painScale.UNABLE_CONTROL_MECHANICAL_VENTILATION),
    label: MessageService.translate('text.unable-to-control-mechanical-ventilation'),
    value: String(painScale.UNABLE_CONTROL_MECHANICAL_VENTILATION),
  },
]
